import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import { ButtonRow } from '../../aws-amplify-react/AmplifyUI';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class ConfirmationDialog extends React.Component {
    state = {
        open: false,
        mode: this.props.mode
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = (user_result) => {
        this.setState({ open: false });
        this.props.confirmResult(user_result);
    };

    render() {
        return (
            <div>
                <Dialog
                    disableBackdropClick
                    disableEscapeKeyDown
                    open={this.props.open}
                    TransitionComponent={Transition}
                    keepMounted
                    maxWidth={'md'}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description">
                   
                    <DialogTitle id="alert-dialog-slide-title" >
                    <div style={{ color: "#f44336"  }}>
                        {this.props.confirm_title}
                        </div>
                    </DialogTitle>
                    
                    <DialogContent>
                        {this.props.info &&
                            <Grid container>
                                {_.map(this.props.info, function (value, key) {
                                    return [<Grid key={key + 1} item xs={4} className="label-style">
                                        {key}
                                    </Grid>,
                                    <Grid key={key + 2} item xs={8} className="value-style">
                                        {value}
                                    </Grid>
                                    ]
                                })}
                            </Grid>}
                        <Grid className='confirm-dialog-message'>
                            <br />
                            {this.props.confirm_message}
                        </Grid>
                    </DialogContent>
                    
                        {this.state.mode ==='confirmSignUp' &&
                        <DialogActions>
                        <ButtonRow
                            onClick={() => this.handleClose(false)}
                            variant="raised">
                            {this.props.button_no}
                        </ButtonRow>
                        <Button
                            variant="raised"
                            onClick={() => this.handleClose(true)}
                            >
                            {this.props.button_yes}
                        </Button>
                        </DialogActions>}
                        {this.state.mode ==='signIn' &&
                        <DialogActions>
                        <ButtonRow
                            variant="raised"
                            onClick={() => this.handleClose(true)}
                            >
                            {this.props.button_yes}
                        </ButtonRow>
                        <Button
                            onClick={() => this.handleClose(false)}
                            variant="raised">
                            {this.props.button_no}
                        </Button>
                        </DialogActions>}
                    
                </Dialog>
            </div >
        );
    }
}

export default ConfirmationDialog;